import { createContext } from 'react';

/**
 * Affiche un message transitoire, équivalent du `toast()` de la maquette
 * validée (`docs/maquette/template.html`).
 */
export type Notifier = (texte: string) => void;

export const ContexteToast = createContext<Notifier | null>(null);
